import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Country } from "mapfre-auditlib";
import { Observable, throwError } from "rxjs";
import * as _ from 'lodash';
import { catchError, map } from "rxjs/operators";
import { Region } from 'mapfre-auditlib';
import { AuthService, CacheService } from 'mapfre-auditlib';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class CountryService {

   className = 'CountryService'

   constructor(private http: HttpClient, private authService: AuthService, private router: Router, private cacheService: CacheService) { }

   getAllCountries(cache = true): Observable<Country[]> | any {
      let cacheKey = "allCountries";
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey);
      } else {
         let observable = this.http.get<Country[]>(environment.base_URL + "/countries").pipe(map((res) => {
            let filtrado =  _.filter(res, it => it.mrkActive);
            this.cacheService.updateCacheData(filtrado, cacheKey)
            return filtrado;
      }))
         this.cacheService.updateCacheReq(cacheKey);
         return observable;
      }
   }

   //!NO se usa
   getAllRegions(): Observable<Country[]> {
      return this.getAllCountries().pipe(map((d: any) => {
         return _.uniqBy(_.map(d, item => item.region), 'txtRegion');
      }));
   }

   newCountry(country) {
      return this.http.post(environment.base_URL + "/countries", country)
   }

   updateCountry(country, id) {
      return this.http.put(environment.base_URL + `/countries/${id}`, country)
   }

   //!NO se usa
   getCountryByUser() {
      return this.authService.getUserAllSO().pipe(map(res => {
         let countriesMap = _.map(res, item => {
            item.country.idOrganizationalStructurePk = [item.idOrganizationalStructurePk];
            return item.country;
         });

         const group = _.chain(countriesMap)
            .groupBy(x => x.idOrganizationalStructurePk)
            .map((value, key) => value)
            .value();

         let countries = _.map(group, country =>
            _.reduce(country, (item, next) => { item.idOrganizationalStructurePk = _.concat(item.idOrganizationalStructurePk, next.idOrganizationalStructurePk); return item; })
         );

         return _.uniqBy(countries, 'idCountryPk');
      }));
   }
}
